import { render } from "./StudentProgress.vue?vue&type=template&id=7738a274"
import script from "./StudentProgress.vue?vue&type=script&lang=js"
export * from "./StudentProgress.vue?vue&type=script&lang=js"

import "./StudentProgress.vue?vue&type=style&index=0&id=7738a274&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__